import React, { PureComponent } from "react";
import { Row, Col, TreeSelect } from 'antd';
import { Form, Input, Select, Upload, Message, Radio, Layout, Button } from 'element-react';
import "./opinionsMailbox.scss";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import img from "../../img/home/characteristic/img1.png";
import 'element-theme-default';


function throttle(fn, ms) {
  let timerId // 创建一个标记用来存放定时器的id
  return function () {
      // 没有定时器等待执行，则表示可以创建新的定时器来执行函数
      if (!timerId) {
        fn.apply(this, arguments)

          timerId = setTimeout(() => {
              // 定时器id清空，表示可以执行下一次调用了
              timerId = null
          }, ms)
      }
  }
}

function debounce(fn, ms) {  //fn:要防抖的函数 ms:时间
  let timerId // 创建一个标记用来存放定时器的返回值
  return function () {
      timerId && clearTimeout(timerId) // 每当用户输入的时候把前一个 setTimeout clear 掉
      // 然后又创建一个新的 setTimeout, 这样就能保证输入字符后的 interval 间隔内如果还有字符输入的话，就不会执行 fn 函数
      timerId = setTimeout(() => { 
          fn.apply(this, arguments)
      }, ms)
  }
}

export default class opinionsMailbox extends PureComponent {
  constructor(props) {
    super(props);
    this.uploadRef = React.createRef();
    this.state = {
      dicts: [],
      form: {
        name: '',
        phoneNumber:'',
        email:'',
        appealCategory:'',
        idNumber:'',

        contactAddress: '',
        title: '',
        content: '',
        // attachmentPath: '',  // 上传路径
        veriCode:'',
        attachmentName:'',
        attachmentPath:'',
      },
      veriCodeAns:'',
      veriCodeImg:'',
      attachmentNameOut:'',  // 文件名
      attachmentPathOut:'',  // 文件路径
      fileOut:'',
      fileListOut:'',
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phoneNumber: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入联系电话'));
            } else {
              if (this.state.form.phone !== '') {
                var pattern = /^1[0-9]{10}$/;
                if (!pattern.test(this.state.form.phone)) {
                  callback(new Error('请输入正确的联系方式'));
                }
              }
              callback();
            }
          } }
        ],
        idNumber: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入身份证号'));
            } else {
              if (this.state.form.identityAccount !== '') {
                var pattern = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                if (!pattern.test(this.state.form.identityAccount)) {
                  callback(new Error('请输入正确的证件号码'));
                }
              }
              callback();
            }
          } }
        ],
        // ^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$
        appealCategory: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        email: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入电子邮箱'));
            } else {
              if (this.state.form.email !== '') {
                var pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                if (!pattern.test(this.state.form.email)) {
                  callback(new Error('请输入正确的电子邮箱格式'));
                }
              }
              callback();
            }
          }  }
        ],
        
        contactAddress: [
          { required: true, message: '请输入联系地址', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入详细内容', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'change' }
        ],
        veriCode: [
          { required: true, message: '请输入正确的验证码', trigger: 'change' }
        ]
      }
    };
  }

  componentDidMount() {
    // getVeriCode
    Http.get(Request.getVeriCode(), {}, obj => {
      console.log(obj);
      if (obj) {
        this.setState({
          veriCodeImg: obj.image,
          veriCodeAns: obj.key
        })
      }
      
    });
    Http.get(Request.get_dict(), {}, obj => {
      console.log(obj);
      if (obj.code == 200) {
        this.setState({
          dicts: obj.data
        })
      }
    });
  }


  handleSubmit=(e)=> {
    const { form,veriCodeAns } = this.state;
    e.preventDefault();
    this.refs.form.validate((valid) => {
      console.log('valid1111111', valid, form)
      form.attachmentName = this.state.attachmentNameOut;
      form.attachmentPath = this.state.attachmentPathOut;
      if (form.name == '' || form.phoneNumber == '' || form.email == '' || form.appealCategory == '' || form.idNumber == '' || form.contactAddress == '' || form.title == '' || form.content == '' || form.veriCode == '') {
        Message.error('必填项不能为空')
        return false;
      }
      if (valid) {
        console.log(form);//saveOmbMsg
        Http.hdjlPost(Request.saveOmbMsg(), form,form.veriCode,veriCodeAns, obj => {
          if (obj.code == 200) {
            Message.success('保存成功！');
            this.uploadRef.current.clearFiles()
            let form = {
              name: '',
              phoneNumber:'',
              email:'',
              appealCategory:'',
              idNumber:'',
              contactAddress: '',
              title: '',
              content: '',
              attachmentPath: '',  // 上传路径
              veriCode:'',
              attachmentName:'',
              attachmentPath:'',
            }
            this.setState({
              form: form
            })
            console.log(21312312);
            this.changeVCode()
            return;
          } else {
            Message.error(obj.msg);
            return;
          }
        })
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  handleReset(e) {
    e.preventDefault();
    let form = {
      name: '',
      phoneNumber:'',
      email:'',
      appealCategory:'',
      idNumber:'',

      contactAddress: '',
      title: '',
      content: '',
      attachmentPath: '',  // 上传路径
      veriCode:'',
    }
    this.setState({
      form: form,
      attachmentNameOut:'',
      attachmentPathOut:'',
    })
    this.refs.form.resetFields();
  }
  
  onChange(key, value) {
    let form = this.state.form;
    if (key == 'dept') {
      if (value && value.value) {
        form.dept_id = value.value;
        form.dept_name = value.label;
      }
      this.setState({
        form: form
      })
    } else {
      this.setState({
        form: Object.assign({}, this.state.form, { [key]: value })
      });
    }
  }

  onBlur(key, e) {
    var value = e.target.value;
    if (value && value != '') {
      if (key == 'idNumber') {
        var pattern = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的证件号码');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      if (key == 'email') {
        var pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的电子邮箱');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      if (key == 'phoneNumber') {
        var pattern = /^1[0-9]{10}$/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的联系方式');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      this.setState({
        form: Object.assign({}, this.state.form, { [key]: value })
      });
    }
  }

  changeVCode=()=>{
    Http.get(Request.getVeriCode(), {}, obj => {
      console.log(obj);
      if (obj) {
        this.setState({
          veriCodeImg: obj.image,
          veriCodeAns: obj.key
        })
      }
    });
  }
  handlePreview(file) {
    console.log('preview');
  }
  
  handleRemove(file, fileList) {
    console.log('remove');
  }
  uploadSuccess(response, file, fileList){  // 附件上传成功调用
    console.log(response);
    console.log(file);
    console.log(fileList);
    this.setState({
      attachmentNameOut:file.name,
      attachmentPathOut:response.data.url,
      fileOut:file,
      fileListOut: fileList,
    })
  }
  render() {
    const { dicts,treeData } = this.state;
    const fileList = [];
    let yzmImgStyle = {
      background: `url(${this.state.veriCodeImg}) no-repeat` 
    };
      return (
        <div className="complaint-container">
          <Form ref="form" model={this.state.form} rules={this.state.rules} labelWidth="80" className="demo-ruleForm">
            <Row gutter={8}>
              <Col sm={{ span: 24}} style={{marginBottom:24}}>
                <span className="title">网上征求意见信箱</span>
              </Col>
              <Col sm={{ span: 10 }}>
                <Form.Item label="姓名" props="name" required={true}>
                  <Input placeholder="" value={this.state.form.name} onChange={this.onChange.bind(this, 'name')} maxLength={10}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 10, offset: 4 }}>
                <Form.Item label="手机号码" props="phoneNumber" required={true}>
                  <Input placeholder="请输入11位手机号码" value={this.state.form.phoneNumber} onChange={this.onChange.bind(this, 'phoneNumber')} onBlur={this.onBlur.bind(this, 'phoneNumber')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 10 }}>
                <Form.Item label="电子邮箱" props="email" required={true}>
                  <Input placeholder="请输入" value={this.state.form.email} onChange={this.onChange.bind(this, 'email')}  onBlur={this.onBlur.bind(this, 'email')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 10, offset: 4 }}>
                <Form.Item label="诉求类别" props="appealCategory" required={true}>
                  <Select value={this.state.form.appealCategory.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'appealCategory')} style={{width: 282}}>
                    {
                      this.state.dicts.map(el => {
                        if (el.code == 'appeal_category') {
                          let arr = [];
                          if (el.children) {
                            arr = el.children.map((item)=>{
                              return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                            })
                          }
                          return arr;
                        }
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24}}>
                <Form.Item label="身份证号" props="idNumber" required={true}>
                  <Input placeholder="请输入18位身份证号" value={this.state.form.idNumber} onChange={this.onChange.bind(this, 'idNumber')} onBlur={this.onBlur.bind(this, 'idNumber')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24}}>
                <Form.Item label="联系地址" props="contactAddress" required={true}>
                  <Input placeholder="请输入联系地址" value={this.state.form.contactAddress} onChange={this.onChange.bind(this, 'contactAddress')} onBlur={this.onBlur.bind(this, 'contactAddress')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24}}>
                <Form.Item label="标题" props="title" required={true}>
                  <Input placeholder="标题勿超过18位汉字" value={this.state.form.title} onChange={this.onChange.bind(this, 'title')} onBlur={this.onBlur.bind(this, 'title')} maxLength={18}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="内容" props="content" required={true}>
                  <Input
                    type="textarea"
                    autosize={{ minRows: 10, maxRows: 20 }}
                    // rows={10}
                    resize='none'
                    value={this.state.form.content}
                    onChange={this.onChange.bind(this, 'content')}
                    placeholder="请详细描述内容"
                    maxLength={1000}
                  />
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="上传附件" props="category" required={true}>
                  <Upload
                    className="upload-demo"
                    action={Request.getDebugUrl() + 'swsmart-file/fileServer/uploadSingle'}
                    onPreview={file => this.handlePreview(file)}
                    onRemove={(file, fileList) => this.handleRemove(file, fileList)}
                    fileList={fileList}
                    onSuccess={(response, file, fileList) =>  this.uploadSuccess(response,file, fileList)}
                    limit={3}
                    ref={this.uploadRef}
                    onExceed={(files, fileList) => {
                      Message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
                    }}
                  >
                    <Button size="small" type="primary">选择文件</Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24}}>
                <Form.Item label="验证码" props="veriCode" required={true} className="yzmCss">
                  <Input placeholder="" value={this.state.form.veriCode} onChange={this.onChange.bind(this, 'veriCode')} style={{width : 160}}></Input>
                  <div className="yzmImg">
                    <div style={yzmImgStyle}></div>
                  </div>
                  <span className="shuaxin" onClick={this.changeVCode.bind(this)}>刷新</span>
                </Form.Item>
              </Col>
            </Row>
            <div className="form-footer">
              <div className="form-btn" onClick={throttle(this.handleSubmit.bind(this),3000) }>提交信息</div>
              <div className="form-btn form-btn1" onClick={this.handleReset.bind(this)}>重置信息</div>
            </div>
          </Form>
        </div>
    );
  }
}
